/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/View', 'assets/js/modules/popup/PopupLight'], function($, View, { default: Popup }) {
    return View.extend({
        events: {
            'click .cancel': 'close',
            'click .delete': 'delete'
        },

        initialize: function(options) {
            this.popup = new Popup(this.$el, {
                width: 400
            });
        },

        show: function() {
            this.popup.open();
        },

        close: function() {
            this.popup.close();
        },

        delete: function() {
            this.close();
            this.trigger('delete');
        }
    });
});
